import React from "react";
import { Typography } from "antd";
import { HomePhoneProduct } from "../../../../../types/homePhone";
import { formatCurrency } from "../../../../../utils/currency";
import SHIPPING_FORM from "../constants";
import ProductThumb from "./ProductThumb";

const { Title } = Typography;

interface OrderSummaryProps {
  product: HomePhoneProduct;
}

const OrderSummary: React.FC<OrderSummaryProps> = ({ product }) => {
  const formattedPrice = formatCurrency(product.price || 0, product.currency);
  const productMeta = [product.brand, product.productType]
    .filter(Boolean)
    .join(" · ");

  return (
    <div className="sf-summary-card">
      <Title level={4} className="sf-summary-title">
        {SHIPPING_FORM.LABELS.ORDER_SUMMARY}
      </Title>

      <div className="sf-summary-product">
        <ProductThumb product={product} />
        <div className="sf-summary-product-info">
          <span className="sf-summary-product-name">{product.name}</span>
          {productMeta && (
            <span className="sf-summary-product-sub">{productMeta}</span>
          )}
        </div>
      </div>

      <div className="sf-summary-rows">
        <div className="sf-summary-row">
          <span>{SHIPPING_FORM.LABELS.SUBTOTAL}</span>
          <span>{formattedPrice}</span>
        </div>
        <div className="sf-summary-row">
          <span>{SHIPPING_FORM.LABELS.SHIPPING}</span>
          <span className="sf-muted">{SHIPPING_FORM.LABELS.CALCULATED}</span>
        </div>
        <div className="sf-summary-row">
          <span>{SHIPPING_FORM.LABELS.TAXES}</span>
          <span className="sf-muted">{SHIPPING_FORM.LABELS.CALCULATED}</span>
        </div>
      </div>

      <div className="sf-summary-total">
        <span>{SHIPPING_FORM.LABELS.TOTAL}</span>
        <span className="sf-total-price">{formattedPrice}</span>
      </div>
    </div>
  );
};

export default OrderSummary;
